import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Shape } from "./Icons";

// A short message in the middle of an otherwise empty public page: page not
// found, access denied, an email being confirmed.
//   <NoticePage icon="warning" tone="bad" title="...">text and buttons</NoticePage>
function NoticePage({ icon = "check", tone = "", title, children }) {
    return (
        <div className="cf-public">
            <Header />
            <main>
                <div className="signin-page">
                    <div className="signin-card has-text-centered">
                        <div className={`cf-big-icon ${tone === "bad" ? "is-bad" : ""}`}><Shape name={icon} /></div>
                        <h1 className="sign-in-title">{title}</h1>
                        {children}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}

export default NoticePage;
